import {
  UserOutlined,
  ApiOutlined,
  SettingOutlined,
  UserAddOutlined,
  ArrowUpOutlined,
  PieChartOutlined,
  ClusterOutlined,
  AppstoreOutlined,
  BankOutlined,
  LaptopOutlined,
  ShareAltOutlined,
  SolutionOutlined,
  TeamOutlined,
  CalendarOutlined,
  NotificationOutlined,
} from "@ant-design/icons";
import { Dropdown, MenuProps } from "antd";
import store from "../../../../controllers/store";
import { ActionShowModalImport } from "../../../../controllers/store/actions/import/import-form-actions";
import React from "react";
import { Actor, User } from "../../..";
import { ActionShowModalPreferences } from "../../../../controllers/store/actions/preferences/preferences-modal-actions";

interface Props {
  user: any;
  commonsEntities: [];
  commonsCapacities: [];
}

const dispatch = store.dispatch;
const AdminMenu = (Props: Props) => {
  console.log("Admin user", Props.user);

  const AdminMenu: MenuProps["items"] = [
    {
      label: "Perfil",
      key: "1",
      icon: <UserOutlined />,
      onClick: () => {
        window.location.href = "/profile";
      },
    },
    {
      label: "Empresa",
      key: "2",
      icon: <BankOutlined />,
      onClick: () => {
        window.location.href = "/entity";
      },
    },
    {
      label: "Instituciones",
      key: "3",
      icon: <LaptopOutlined />,
      onClick: () => {
        window.location.href = "/ies";
      },
    },
    {
      label: "Investigadores",
      key: "4",
      icon: <SolutionOutlined />,
      onClick: () => {
        window.location.href = "/searchers";
      },
    },
    {
      label: "Grupos de investigación",
      key: "5",
      icon: <TeamOutlined />,
      onClick: () => {
        window.location.href = "/groups";
      },
    },
    {
      label: "Otras Entidades",
      key: "6",
      icon: <ClusterOutlined />,
      children: Props.commonsEntities
        .filter((c: any) => c.collection_name === Actor.Commons)
        .map((c: any, index) => ({
          label: c.actor,
          key: `6-${index}`,
          onClick: () => {
            window.location.href = `/commons/${c.id}`;
          },
        })),
    },
    {
      label: "Productos",
      key: "7",
      icon: <AppstoreOutlined />,
      onClick: () => {
        window.location.href = "/products";
      },
    },
    {
      label: "Proyectos",
      key: "8",
      icon: <ShareAltOutlined />,
      onClick: () => {
        window.location.href = "/projects";
      },
    },
    {
      label: "Otras capacidades",
      key: "9",
      icon: <ClusterOutlined />,
      children: Props.commonsCapacities
        .filter((c: any) => c.collection_name === "commons_capacities")
        .map((c: any, index) => ({
          label: c.name,
          key: `9-${index}`,
          onClick: () => {
            window.location.href = `/commons-capacities/${c.id}`;
          },
        })),
    },
    {
      label: "Crear evento",
      key: "10",
      icon: <CalendarOutlined />,
      onClick: () => {
        window.location.href = "/events";
      },
    },
    {
      label: "Crear convocatoria",
      key: "11",
      icon: <NotificationOutlined />,
      onClick: () => {
        window.location.href = "/announcement";
      },
    },
    {
      label: "Preferencias",
      key: "12",
      icon: <SettingOutlined />,
      onClick: () => {
        dispatch(ActionShowModalPreferences());
      },
    },
    {
      label: "Estadistcas",
      key: "13",
      icon: <PieChartOutlined />,
      onClick: () => {
        window.location.href = "/analytics";
      },
    },
    {
      label: "Opciones",
      key: "14",
      icon: <SettingOutlined />,
      children: [
        {
          label: "Usuarios",
          key: "14-1",
          icon: <UserAddOutlined />,
          onClick: () => {
            window.location.href = "/users";
          },
        },
        {
          label: "Importar datos",
          key: "14-2",
          icon: <ArrowUpOutlined />,
          onClick: () => {
            dispatch(ActionShowModalImport());
          },
        },
      ],
    },
    {
      label: "Cerrar sesión",
      key: "15",
      icon: <ApiOutlined />,
      danger: true,
      disabled: false,
      onClick: () => {
        localStorage.removeItem("user");
        localStorage.removeItem("jwt");
        window.location.href = "/login";
      },
    },
  ];

  const menuProps = {
    items: AdminMenu,
    onClick: () => {},
  };

  const Menu: React.FC = (Props: MenuProps) => {
    return (
      <a href="#" onClick={(e) => e.preventDefault()}>
        <svg viewBox="0 0 100 80" width="25" height="25">
          <rect fill="#ff974d" width="100" height="20"></rect>
          <rect fill="#ff974d" y="30" width="100" height="20"></rect>
          <rect fill="#ff974d" y="60" width="100" height="20"></rect>
        </svg>
      </a>
    );
  };

  return (
    <Dropdown.Button
      type="link"
      icon={<Menu />}
      menu={menuProps}
      onClick={() => {}}
    >
      {`${Props.user.me.first_name}`}
    </Dropdown.Button>
  );
};

export default AdminMenu;
